import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import hedgeFunds from '../../data/hedgefunds.json'
import defense from '../../data/defense.json'

const INDUSTRIES = ['All', 'Finance', 'Aerospace & Defense']

const ROLE_CATEGORIES = [
  'Software Engineering', 'Data & Analytics', 'Product', 'Sales',
  'Marketing', 'Operations', 'Finance & Accounting', 'Legal', 'HR & Recruiting', 'Design',
]

const ALL_COMPANIES = [
  ...hedgeFunds.map(c => ({ name: c.name, careers_url: c.careers_url, metric: c.aum ? `${c.aum}` : null, metricLabel: 'AUM', industry: 'Finance' })),
  ...defense.map(c => ({ name: c.name, careers_url: c.careers_url, metric: c.stock_change || null, metricLabel: 'today', industry: 'Aerospace & Defense' })),
]

const Panel = styled.div`width:300px;flex-shrink:0;background:#0f1117;border-left:1px solid #1e2028;display:flex;flex-direction:column;height:100%;overflow:hidden;@media(max-width:900px){width:100%;border-left:none;height:auto;overflow:visible;}`
const Header = styled.div`padding:.85rem 1rem;border-bottom:1px solid #1e2028;display:flex;align-items:center;justify-content:space-between;flex-shrink:0`
const FilterRow = styled.div`display:flex;gap:.35rem;padding:.55rem 1rem;border-bottom:1px solid #1e2028;flex-shrink:0;flex-wrap:wrap`
const FilterBtn = styled.button`font-size:.62rem;padding:.2rem .55rem;border-radius:3px;font-family:'SFMono-Regular',monospace;cursor:pointer;letter-spacing:.06em;text-transform:uppercase;transition:all .12s;border:1px solid ${p => p.active ? '#3b82f6' : '#21262d'};background:${p => p.active ? '#1e2f4a' : 'transparent'};color:${p => p.active ? '#58a6ff' : '#555'};&:hover{border-color:#3b82f6;color:#58a6ff}`
const RoleRow = styled.div`display:flex;gap:.3rem;padding:.4rem 1rem .5rem;border-bottom:1px solid #1e2028;flex-shrink:0;flex-wrap:wrap;overflow:hidden;max-height:${p => p.open ? '200px' : '0'};transition:max-height .2s;padding-top:${p => p.open ? '.4rem' : '0'};padding-bottom:${p => p.open ? '.5rem' : '0'}`
const RoleBtn = styled.button`font-size:.6rem;padding:.15rem .45rem;border-radius:3px;font-family:'SFMono-Regular',monospace;cursor:pointer;letter-spacing:.05em;transition:all .12s;border:1px solid ${p => p.active ? '#58a6ff' : '#1e2028'};background:${p => p.active ? '#1e2f4a' : 'transparent'};color:${p => p.active ? '#79c0ff' : '#444'};&:hover{color:#79c0ff;border-color:#58a6ff}`
const SearchInput = styled.input`width:calc(100% - 2rem);margin:.55rem 1rem;padding:.4rem .6rem;background:#161b22;border:1px solid #21262d;border-radius:4px;color:#c9d1d9;font-size:.75rem;font-family:'SFMono-Regular',monospace;outline:none;flex-shrink:0;&::placeholder{color:#3d444d};&:focus{border-color:#3b82f6}`
const Count = styled.div`font-size:.63rem;color:#444;font-family:monospace;letter-spacing:.08em;padding:0 1rem .35rem;flex-shrink:0`
const List = styled.div`flex:1;overflow-y:auto;padding:0 .5rem 1rem;&::-webkit-scrollbar{width:4px}&::-webkit-scrollbar-track{background:transparent}&::-webkit-scrollbar-thumb{background:#21262d;border-radius:2px}@media(max-width:900px){overflow-y:visible;flex:none;}`
const Card = styled.div`padding:.6rem .75rem;border-radius:5px;border:1px solid #1e2028;margin-bottom:.4rem;transition:all .12s;background:#161b22;&:hover{border-color:#2d3748}`
const CardTop = styled.div`display:flex;justify-content:space-between;align-items:center;gap:.4rem;margin-bottom:.25rem`
const CompanyName = styled.span`font-size:.78rem;font-weight:700;color:#e6edf3;font-family:'SFMono-Regular',monospace;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`
const MetricBadge = styled.span`font-size:.62rem;font-family:monospace;white-space:nowrap;flex-shrink:0;color:${p => p.isStock ? '#3fb950' : '#555'}`
const IndustryTag = styled.span`font-size:.58rem;color:#444;font-family:monospace;letter-spacing:.06em;text-transform:uppercase`
const CardBottom = styled.div`display:flex;justify-content:space-between;align-items:center`
const BrowseBtn = styled.a`font-size:.63rem;padding:.2rem .5rem;background:transparent;color:#3b82f6;border:1px solid #1e3a5f;border-radius:3px;font-family:monospace;text-decoration:none;transition:all .12s;white-space:nowrap;&:hover{background:#161e2e;border-color:#3b82f6}`
const Hint = styled.div`margin:.5rem 1rem 0;padding:.45rem .6rem;background:#0f1a0f;border:1px solid #1a2e1a;border-radius:4px;font-size:.6rem;color:#3d5a3d;font-family:monospace;line-height:1.5;flex-shrink:0`
const RoleToggle = styled.button`font-size:.6rem;padding:.15rem .5rem;background:transparent;border:1px solid #21262d;border-radius:3px;color:#444;font-family:monospace;cursor:pointer;transition:all .12s;&:hover{color:#79c0ff;border-color:#58a6ff}`

export const FerlJobs = ({ wizardMode = false }) => {
  const [search, setSearch] = useState('')
  const [industry, setIndustry] = useState('All')
  const [roles, setRoles] = useState([])
  const [rolesOpen, setRolesOpen] = useState(false)
  const navigate = useNavigate()

  const toggleRole = (r) => setRoles(prev => prev.includes(r) ? prev.filter(x => x !== r) : [...prev, r])

  const filtered = ALL_COMPANIES.filter(c => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase())
    const matchIndustry = industry === 'All' || c.industry === industry
    return matchSearch && matchIndustry
  })

  const Wrapper = wizardMode ? 'div' : Panel
  const wrapperProps = wizardMode
    ? { style: { background: '#0f1117', width: '100%' } }
    : {}

  return (
    <Wrapper {...wrapperProps}>
      <Header>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
          <a href="https://ferl.fyi" target="_blank" rel="noopener noreferrer" style={{ fontSize: '.9rem', fontWeight: 800, color: '#e8e8e2', fontFamily: 'monospace', textDecoration: 'none' }}>ferl</a>
          <span style={{ color: '#555', fontFamily: 'monospace', fontSize: '.8rem' }}>/</span>
          <span style={{ fontSize: '.7rem', color: '#555', fontFamily: 'monospace' }}>browse</span>
        </div>
        <button onClick={() => navigate('/jobs/hiring')} style={{ fontSize: '.68rem', color: '#3b82f6', fontFamily: 'monospace', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>Companies hiring →</button>
      </Header>

      {/* Industry filter */}
      <FilterRow>
        {INDUSTRIES.map(ind => (
          <FilterBtn key={ind} active={industry === ind} onClick={() => setIndustry(ind)}>{ind}</FilterBtn>
        ))}
        <RoleToggle onClick={() => setRolesOpen(o => !o)}>
          role {roles.length > 0 ? `(${roles.length})` : '▾'}
        </RoleToggle>
      </FilterRow>

      {/* Role filter (collapsible) */}
      <RoleRow open={rolesOpen}>
        {ROLE_CATEGORIES.map(r => (
          <RoleBtn key={r} active={roles.includes(r)} onClick={() => toggleRole(r)}>{r}</RoleBtn>
        ))}
      </RoleRow>

      <Hint>{wizardMode ? 'browse → find a job posting → copy URL → paste above' : 'browse → find a job → paste URL in paste url tab'}</Hint>
      <SearchInput placeholder="search companies..." value={search} onChange={e => setSearch(e.target.value)} />
      <Count>{filtered.length} {filtered.length === 1 ? 'company' : 'companies'}{industry !== 'All' ? ` · ${industry}` : ''}</Count>

      <List>
        {filtered.map(company => (
          <Card key={company.name}>
            <CardTop>
              <CompanyName>{company.name}</CompanyName>
              {company.metric && (
                <MetricBadge isStock={company.metricLabel === 'today'}>
                  {company.metricLabel === 'today' ? `▲ ${company.metric}` : company.metric}
                </MetricBadge>
              )}
            </CardTop>
            <CardBottom>
              <IndustryTag>{company.industry}</IndustryTag>
              <BrowseBtn href={company.careers_url} target="_blank" rel="noopener noreferrer">browse jobs →</BrowseBtn>
            </CardBottom>
          </Card>
        ))}
      </List>
    </Wrapper>
  )
}
